var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparklingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 4.198C12.7887 4.198 13.6981 3.28857 13.6981 2.16675H14.6356C14.6356 3.28857 15.545 4.198 16.6668 4.198V5.1355C15.545 5.1355 14.6356 6.04492 14.6356 7.16675H13.6981C13.6981 6.04492 12.7887 5.1355 11.6668 5.1355V4.198ZM0.833496 9.66675C3.59492 9.66675 5.8335 7.42817 5.8335 4.66675H7.50016C7.50016 7.42817 9.73875 9.66675 12.5002 9.66675V11.3334C9.73875 11.3334 7.50016 13.572 7.50016 16.3334H5.8335C5.8335 13.572 3.59492 11.3334 0.833496 11.3334V9.66675ZM14.3752 12.1667C14.3752 13.6625 13.1626 14.8751 11.6668 14.8751V16.1251C13.1626 16.1251 14.3752 17.3377 14.3752 18.8334H15.6252C15.6252 17.3377 16.8377 16.1251 18.3335 16.1251V14.8751C16.8377 14.8751 15.6252 13.6625 15.6252 12.1667H14.3752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklingIcon);
export default __webpack_public_path__ + "static/media/sparklingIcon.f8d3d32fdbd98486c0076493eee54f71.svg";
export { ForwardRef as ReactComponent };